export const SIMPLE_CONFIG = 'simple';
export const EXTENDED_CONFIG = 'extended';

export const VOTE_DEFAULTS = {
  name: '',
  description: '',
  contactId: null,
  config: SIMPLE_CONFIG,
};
